import React from 'react'

export default function Tophead() {
  return (
    <div style={{marginTop:"30px",fontFamily: "Monoton",color: "white"
    }}>
      <h3>What &nbsp; will &nbsp; you &nbsp; design &nbsp; today &nbsp; ?</h3>
    </div>
  )
}

//#2382A0
//#434343 - deep space